import { useEffect, useState, useRef, useContext } from "react";
import "./shoppingCart.scss";
import { ShopContext } from "../../context/ShopContext";
import { useNavigate } from "react-router-dom";
import { formatSize } from "../../utilityFunction/convertUnits";
import { cardImage } from "../../utilityFunction/cardImage";

export default function ShoppingCart({ ShopingStyle }) {
  //const [isCartVisible, setCartVisible] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true); //used to determine if a message should be show empty cart
  const navigate = useNavigate();

  const {
    removeItemCart,
    addToCart,
    clearCart,
    cart,
    cartRef,
    isCartVisible,
    toggleVisible,
    totalCart,
    calculateItemTotal,
    removeAllSpecificItem,
    totalUniqueItems,
    calculateTotalItems,
  } = useContext(ShopContext);

  useEffect(() => {
    setIsEmpty(totalCart <= 0);
  }, [cart, totalCart]);

  const handleCheckoutClick = (e) => {
    e.preventDefault();

    if (!isEmpty) {
      toggleVisible("setCartVisible");
      navigate("/checkout");
    } else {
      alert("Your cart is empty!");
    }
  };

  return (
    <div className="Shopping-Cart-Container" ref={cartRef}>
      <div className="Shopping-Cart-Container-Outer">
        <i
          className={`${ShopingStyle} fa-solid fa-basket-shopping`}
          onClick={toggleVisible}
        ></i>
        {calculateTotalItems() > 0 && (
          <div
            className="Shopping-Cart-Container-Count-Main"
            onClick={toggleVisible}
          >
            <p>{calculateTotalItems()}</p>
          </div>
        )}
      </div>
      {isCartVisible && (
        <div className="Shopping-Cart-Top-Bar">
          <div className="Shopping-Cart-Title">
            <p className="Shopping-Cart-TitleStyle">Shopping Cart</p>
            <button className="Shopping-Cart-ClearButton" onClick={clearCart}>
              {" "}
              Remove all
            </button>
          </div>
          <section className="Shop-Cart-Items-Section">
            <ul className="Shop-Cart-Items-List">
              {cart.map((product) => (
                <li key={product.variant_id} className="Shop-Cart-Items-Inner">
                  <div className="Shop-Cart-Product">
                    <div className="Shop-Cart-Image">
                      <img
                        className="Shop-Cart-Image-Inner"
                        src={cardImage(product.image)}
                        alt=""
                      ></img>
                    </div>
                    <div className="Shop-Cart-Description-Section">
                      <div className="Shop-Cart-Main-Description">
                        <p className="Shop-Cart-Product-Name">
                          {product.product_name}
                        </p>
                        {typeof product.tagline === "string" &&
                          product.tagline.trim() !== "" && (
                            <span className="Shop-Cart-Product-Tagline">
                              {product.tagline.trim()}
                            </span>
                          )}
                        <div className="Shop-Cart-Product-Size">
                          <span>Size:</span>
                          <span>
                            {
                              formatSize(product.size_name, product.size_value)
                                .label
                            }
                          </span>
                        </div>
                      </div>
                      <div className="Shop-Cart-Product-Quantity">
                        <button
                          className="Shop-Cart-Product-Quantity-Remove"
                          onClick={() => removeItemCart(product.variant_id)}
                        >
                          -
                        </button>
                        <p className="Shop-Cart-Product-Quantity-Amount">
                          {product.quantity}
                        </p>
                        <button
                          className="Shop-Cart-Product-Quantity-Add"
                          onClick={() => addToCart(product)}
                        >
                          +
                        </button>
                      </div>
                      <div className="Shop-Cart-Product-Quantity-ItemSummary">
                        <p className="Shop-Cart-Product-Quantity-ItemPrice">
                          ${calculateItemTotal(product.quantity, product.price)}
                        </p>
                        <p
                          className="Shop-Cart-Product-Quantity-ItemRemove"
                          onClick={() =>
                            removeAllSpecificItem(product.variant_id)
                          }
                        >
                          Remove
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </section>
          <div className="Shop-Cart-Items-Total-Section">
            <div className="Shop-Cart-Items-Total-SectionStyle">
              <div className="Shop-Cart-Items-Total-Subtotal">
                <p className="Shop-Cart-Items-Total-Text">Subtotal:</p>
                <p className="Shop-Cart-Items-Total-CountItem">
                  {totalUniqueItems} {totalUniqueItems === 1 ? "item" : "items"}
                </p>
              </div>
              <p className="Shop-Cart-Items-Total-Amount">
                C ${totalCart.toFixed(2)}
              </p>
            </div>
          </div>
          <div className="Shop-Cart-Buttons">
            <button
              className="Shop-Cart-Checkout"
              onClick={handleCheckoutClick}
            >
              Checkout
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
